"use strict";
/* globals module */
/**
 * @module roleRoute
 * @description Baasic Role Route Definition provides Baasic route templates which can be expanded to Baasic REST URIs. Various services can use Baasic Role Route Service to obtain needed routes while other routes will be obtained through HAL. By convention, all route services use the same function names as their corresponding services.
 */
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var inversify_1 = require("inversify");
var common_1 = require("../../../common");
;
var contracts_1 = require("../../../core/contracts");
var _1 = require("./");
var RoleRoute = /** @class */ (function (_super) {
    tslib_1.__extends(RoleRoute, _super);
    function RoleRoute(appOptions, roleBatchRoute) {
        var _this = _super.call(this, appOptions) || this;
        _this.appOptions = appOptions;
        _this.roleBatchRoute = roleBatchRoute;
        /**
        * Find route with route and query parameters.
        **/
        _this.findRoute = 'lookups/roles/{?searchQuery,page,rpp,sort,embed,fields}';
        /**
        * Get route with route and query parameters.
        **/
        _this.getRoute = 'lookups/roles/{id}/{?embed,fields}';
        /**
        * Create route with route and query parameters.
        **/
        _this.createRoute = 'lookups/roles';
        /**
        * Update route with route and query parameters.
        **/
        _this.updateRoute = 'lookups/roles/{id}';
        /**
        * Remove route with route and query parameters.
        **/
        _this.removeRoute = 'lookups/roles/{id}';
        return _this;
    }
    Object.defineProperty(RoleRoute.prototype, "batch", {
        /**
         * Provides direct access to 'roleBatchRoute'
         * @method
        **/
        get: function () {
            return this.roleBatchRoute;
        },
        enumerable: true,
        configurable: true
    });
    /**
     * Parses find role route which can be expanded with additional options. Supported items are:
     * - `searchQuery` - A string value used to identify role resources using the phrase search.
     * - `page` - A value used to set the page number, i.e. to retrieve certain role subset from the storage.
     * - `rpp` - A value used to limit the size of result set per page.
     * - `sort` - A string used to set the role property to sort the result collection by.
     * @method
     * @param options Query resource options object.
     * @example roleRoute.find({searchQuery: '<search-phrase>'});
     **/
    RoleRoute.prototype.find = function (options) {
        return _super.prototype.baseFind.call(this, this.findRoute, options);
    };
    /**
     * Parses get role route which should be expanded with the role Id. Note that the role Id is the primary key of the role.
     * @method
     * @param id Role unique indentifer.
     * @param options Query resource options object.
     * @example roleRoute.get().expand({id: '<role-id>'});
     **/
    RoleRoute.prototype.get = function (id, options) {
        return _super.prototype.baseGet.call(this, this.getRoute, id, options);
    };
    /**
     * Parses create role route; this URI template does not expose any additional options.
     * @method
     * @example roleRoute.create();
     **/
    RoleRoute.prototype.create = function () {
        return _super.prototype.baseCreate.call(this, this.createRoute, {});
    };
    /**
     * Parses update role route.
     * @method
     * @param data A role object used to update specified role resource.
     * @example roleRoute.update(data);
     */
    RoleRoute.prototype.update = function (data) {
        return _super.prototype.baseUpdate.call(this, this.updateRoute, data);
    };
    /**
     * Parses delete role route.
     * @method
     * @param data A role object used to delete specified role resource.
     * @example roleRoute.delete(data);
     */
    RoleRoute.prototype.delete = function (data) {
        return _super.prototype.baseDelete.call(this, this.removeRoute, data);
    };
    var _a, _b;
    RoleRoute = tslib_1.__decorate([
        inversify_1.injectable(),
        tslib_1.__param(0, inversify_1.inject(contracts_1.TYPES.IAppOptions)),
        tslib_1.__param(1, inversify_1.inject(_1.TYPES.RoleBatchRoute)),
        tslib_1.__metadata("design:paramtypes", [typeof (_a = typeof contracts_1.IAppOptions !== "undefined" && contracts_1.IAppOptions) === "function" ? _a : Object, typeof (_b = typeof _1.RoleBatchRoute !== "undefined" && _1.RoleBatchRoute) === "function" ? _b : Object])
    ], RoleRoute);
    return RoleRoute;
}(common_1.BaseRoute));
exports.RoleRoute = RoleRoute;
/**
 * @overview
 ***Notes:**
 - Refer to the [Baasic REST API](http://dev.baasic.com/api/reference/home) for detailed information about available Baasic REST API end-points.
 - [URI Template](https://github.com/Baasic/uritemplate-js) syntax enables expanding the Baasic route templates to Baasic REST URIs providing it with an object that contains URI parameters.
 - All end-point objects are transformed by the associated route definition.
*/ 
